<app-side-color-card color="primary-1">
  <div class="holder" content>
    <div class="upper-section">
      <h3 class="title">POSIÇÕES ESCANINHO</h3>
      <div class="buttons-wrapper">
        <button mat-raised-button class="cancel" (click)="emitCancel()">cancelar</button>
        <button mat-raised-button class="save" (click)="emitSave()">salvar</button>
      </div>
    </div>
    <div class="table">
      <div class="items">
        <div class="header">
          <div class="name column">Apelido</div>
          <div class="type column">Coordenada</div>
          <div class="action column"></div>
        </div>
        <div class="item" *ngFor="let position of positions" 
          [ngClass]="{
            'primary-1': position.type === 'STOCK',
            'secondary-3': position.type === 'DOCK',
            'out' : position.type === 'EXPEDITION',
            'quality' : position.type === 'QUALITY_CONTROL',
            'red' : position.type === 'DIVERGENT_STOCK',
            'gray' : position.type === 'STREET',
            'yellow' : position.type === 'DAMAGES',
            'picking' : position.type === 'PICKING',
            'provision' : position.type === 'PROVISION',
            'picking-miscellaneous' : position.type === 'PICKING_MISCELLANEOUS',
            'in' : position.type === 'IN',
            'black': position.type === 'EXIT',
            'selected': position.selected,
            'pigeonhole': position.type === 'PIGEONHOLE'
          }">
          <div class="name column">{{position?.alias || '---'}}</div>
          <div class="type column">{{getCoordinates(position.x, position.y)}}</div>
          <div class="action column">
            <span class="uil uil-times" title="Remover" (click)="removePosition(position); $event.stopPropagation()"></span>
          </div>
        </div>
      </div>
    </div>
  </div>

</app-side-color-card>